var _a, _b;
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useIntl } from 'react-intl';
import Typography from './Typography';
import defaultPreferencesDialogTemplate from '../consts/default-preferences-template';
import theme from '../consts/theme';
import { srOnly } from '../styles/a11y';
var rootStyles = css({
    overflowX: 'auto',
});
var tableStyles = css({
    borderCollapse: 'collapse',
    border: "1px solid ".concat(theme.colors.lightGray),
    minWidth: '100%',
});
var cellStyles = css({
    backgroundColor: theme.colors.white,
    border: "1px solid ".concat(theme.colors.lightGray),
    borderBottom: '1px solid #e0e0e0',
    fontSize: '0.875rem',
    padding: '1rem',
    textAlign: 'left',
    verticalAlign: 'middle',
});
var radioCellStyles = css((_a = {
        width: '6rem'
    },
    _a[theme.breakpoints.md] = {
        width: '9rem',
    },
    _a));
var inputWrapperStyles = css((_b = {
        border: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
        margin: 0,
        padding: 0,
        width: '100%'
    },
    _b[theme.breakpoints.md] = {
        flexDirection: 'row',
        gap: '1rem',
    },
    _b));
var PreferencesTable = function (_a) {
    var preferences = _a.preferences, onCategoryChange = _a.onCategoryChange;
    var t = useIntl().formatMessage;
    var categories = defaultPreferencesDialogTemplate.categories, headings = defaultPreferencesDialogTemplate.headings;
    var handleCategoryChange = function (event) {
        var _a = event.target, name = _a.name, value = _a.value;
        onCategoryChange(name, JSON.parse(value));
    };
    return (_jsx("div", { css: rootStyles, children: _jsxs("table", { css: tableStyles, children: [_jsx("thead", { children: _jsx("tr", { children: headings.map(function (h) { return (_jsx("th", { css: cellStyles, children: _jsx(Typography, { El: "span", children: t({ id: h.name }) }) }, h.key)); }) }) }), _jsx("tbody", { children: categories.map(function (c) { return (_jsxs("tr", { children: [_jsx("td", { css: [cellStyles, radioCellStyles], children: _jsxs("fieldset", { css: inputWrapperStyles, children: [_jsx("legend", { css: srOnly, children: t({ id: 'allow_tracking_for_category' }, { category: t({ id: c.name }) }) }), _jsxs("div", { children: [_jsx("input", { "data-cy": "radio-allow-".concat(c.key), type: "radio", name: c.key, id: "".concat(c.key, "-allow"), checked: !!preferences[c.key], value: "true", onChange: handleCategoryChange, style: { appearance: 'revert' } }), ' ', _jsx("label", { htmlFor: "".concat(c.key, "-allow"), children: _jsx(Typography, { El: "span", children: t({ id: 'yes' }) }) })] }), _jsxs("div", { children: [_jsx("input", { "data-cy": "radio-disallow-".concat(c.key), type: "radio", name: c.key, id: "".concat(c.key, "-disallow"), checked: !preferences[c.key], value: "false", "aria-label": t({ id: 'disallow_tracking_for_category' }, { category: t({ id: c.name }) }), onChange: handleCategoryChange, style: { appearance: 'revert' } }), ' ', _jsx("label", { htmlFor: "".concat(c.key, "-disallow"), children: _jsx(Typography, { El: "span", children: t({ id: 'no' }) }) })] })] }) }), _jsxs("td", { css: cellStyles, children: [_jsx(Typography, { css: css({
                                            fontWeight: 'bold',
                                            marginBottom: '0.5rem',
                                        }), children: t({ id: c.name }) }), _jsx(Typography, { variant: "caption", children: t({ id: c.description }) })] })] }, c.key)); }) })] }) }));
};
export default PreferencesTable;
